export default "public/CompliSpacePrimary.png";